
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/reels",
      function () {
        return require("private-next-pages/3catinfo/reels/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/reels"])
      });
    }
  